class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper)
      facetWrapper.addEventListener("keyup", window.onKeyUpEscape);

    const mobFilterDrawerActivationElement = document.querySelector(
      ".search-page-facets-container menu-drawer details"
    );
    const facetsContainer = document.querySelector(
      ".search-page-facets-container"
    );
    if (mobFilterDrawerActivationElement && facetsContainer) {
      mobFilterDrawerActivationElement.addEventListener("toggle", function (e) {
        const method = mobFilterDrawerActivationElement.open ? "add" : "remove";
        facetsContainer.classList[method]("drawer-open");
      });
    }

    document.addEventListener("DOMContentLoaded", function () {
      if (window.innerWidth > 768) {
        return;
      }

      const $detailsElements = document.querySelectorAll(
        ".disclosure-has-popup.facets__disclosure"
      );

      // Função para alternar a classe "hidden" nos elementos fora do main
      function toggleHiddenElements(isOpen) {
        const $mainElement = document.querySelector("main");
        const $elementsOutsideMain = Array.from(document.body.children).filter(
          (child) => child !== $mainElement
        );
        $elementsOutsideMain.forEach(($element) => {
          if (isOpen) {
            $element.classList.add("hidden");
            document.body.style.overflow = "hidden";
          } else {
            $element.classList.remove("hidden");
            document.body.style.overflow = "";
          }
        });
      }

      $detailsElements.forEach(($detailsElement) => {
        $detailsElement.addEventListener("toggle", function () {
          const isOpen = $detailsElement.hasAttribute("open");
          toggleHiddenElements(isOpen);
        });
      });
    });

    const observeDOMChanges = (targetNode) => {
      const observerConfig = { childList: true, subtree: true };

      const callback = function (mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            closePopupOnClick();
            toggleHiddenFacetsCounter();
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, observerConfig);
    };

    const toggleHiddenFacetsCounter = () => {
      const $counterElements = document.querySelectorAll(
        ".facets-filter-counter"
      );
      const $results = document.querySelector(".filters-results-wrapper");
      const $priceRange = document.querySelector(".active-price-range");

      let hasVisibleCounter = false;

      $counterElements.forEach((counterElement) => {
        const count = Number(counterElement.innerText);

        if (count > 0) {
          counterElement.classList.remove("hidden");
          hasVisibleCounter = true;
        } else {
          counterElement.classList.add("hidden");
        }
      });

      if (hasVisibleCounter) {
        $results.classList.remove("hidden");
      } else {
        $results.classList.add("hidden");
      }

      if ($priceRange) {
        const priceRangeContent = $priceRange.innerText.trim();

        if (priceRangeContent) {
          $priceRange.classList.remove("hidden");
          $results.classList.remove("hidden");
        } else {
          $priceRange.classList.add("hidden");
        }
      } else {
        return;
      }
    };

    const closePopupOnClick = () => {
      const $closeButtons = document.querySelectorAll(".facets__display-close");
      const $disclosurePopUps = document.querySelectorAll(
        ".disclosure-has-popup"
      );

      $closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
          $disclosurePopUps.forEach((disclosurePopUp) => {
            disclosurePopUp.removeAttribute("open");
          });
        });
      });
    };

    document.addEventListener("DOMContentLoaded", () => {
      closePopupOnClick();
      toggleHiddenFacetsCounter();

      const targetNode =
        document.querySelector("#FacetsWrapperDesktop") || document.body;
      observeDOMChanges(targetNode);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );

    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");

    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static toggleHiddenElements() {
    const hasPrivateSale = sessionStorage.getItem("PrivateSale");
    if (!hasPrivateSale) return;

    const notPrivateSaleElements =
      document.querySelectorAll(".not-private-sale");
    const privateSaleElements = document.querySelectorAll(
      ".private-sale-price"
    );

    notPrivateSaleElements.forEach(function (element) {
      element.classList.add("hidden");
    });

    privateSaleElements.forEach(function (element) {
      element.classList.remove("hidden");
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .then(() => {
        initLazyload();
        initInfiniteScroll();
        FacetFiltersForm.toggleHiddenElements();
        toggleHiddenFacetsCounter();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.toggleHiddenElements();
    toggleHiddenFacetsCounter();
  }

  static renderProductGridContainer(html) {
    const productGridClasses =
      document.getElementById("product-grid").classList;
    const fetchedHtmlPage = new DOMParser().parseFromString(html, "text/html");
    const newUlGrid = fetchedHtmlPage.getElementById("product-grid");

    newUlGrid.removeAttribute("class");
    newUlGrid.classList.add(...Array.from(productGridClasses));

    const currentGrid = document.getElementById("ProductGridContainer");
    const newGrid = fetchedHtmlPage.getElementById("ProductGridContainer");
    currentGrid.innerHTML = newGrid.innerHTML;

    FacetFiltersForm.toggleHiddenElements(); // Chame a função aqui também para garantir
    initProductGrid();
  }

  static renderProductCount(html) {
    const _document = new DOMParser().parseFromString(html, "text/html");
    const _countContainer = _document.getElementById("ProductCount");
    if (!_countContainer) return;
    const _count = _countContainer.innerHTML;
    const container = document.getElementById("ProductCount");
    if (!container) return;
    const containerDesktop = document.getElementById("ProductCountDesktop");
    if (!containerDesktop) return;
    container.innerHTML = _count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const _element = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      if (!_element) return;
      _element.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
      document.dispatchEvent(
        new Event(window.FarmRio.events.searchFilterActivated)
      );
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
      ".active-facets-clearAll-mobile",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const element = document.querySelector(selector);
      element.innerHTML = activeFacetsElement.innerHTML;
      element.className = activeFacetsElement.className;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const filterCountContainer = document.querySelector("#js-filter-count");

    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      let a = html.querySelector(".mobile-facets__count");
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    if (filterCountContainer) {
      const listItems = html.body.querySelectorAll("#product-grid li");
      const listItemsCount = listItems.length;
      filterCountContainer.innerText = listItemsCount + " productos";
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");
    const filterListCounter = target.querySelector(".filter-list-counter");

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
      const numberFilter = parseInt(sourceElement.innerText);
      filterListCounter.innerText =
        numberFilter > 1
          ? numberFilter + " seleccionados"
          : numberFilter + " seleccionado";
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const $resultsWrapper = document.querySelector(".filters-results-wrapper");
    const formData = new FormData(event.target.closest("form"));
    let searchParams = new URLSearchParams(formData).toString();

    if (!searchParams.includes("filter.v.availability")) {
      searchParams += `&filter.v.availability=1`;
    }

    if (searchParams) {
      $resultsWrapper.classList.remove("hidden");
    }

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

function initProductGrid() {
  const cleanupEventListeners = () => {
    const $slider = document.querySelector(".range-slider");
    const $iconSmall = document.querySelector(".icon-grid-small-mobile");
    const $iconLarge = document.querySelector(".icon-grid-large-mobile");
    const $buttonsWrapper = document.querySelector(".button-columns-wrapper");

    if ($slider) {
      const newSlider = $slider.cloneNode(true);
      $slider.parentNode.replaceChild(newSlider, $slider);
    }

    if ($iconSmall) {
      const newIconSmall = $iconSmall.cloneNode(true);
      $iconSmall.parentNode.replaceChild(newIconSmall, $iconSmall);
    }

    if ($iconLarge) {
      const newIconLarge = $iconLarge.cloneNode(true);
      $iconLarge.parentNode.replaceChild(newIconLarge, $iconLarge);
    }

    if ($buttonsWrapper) {
      const newButtonsWrapper = $buttonsWrapper.cloneNode(true);
      $buttonsWrapper.parentNode.replaceChild(
        newButtonsWrapper,
        $buttonsWrapper
      );
    }
  };
  cleanupEventListeners();

  const $productGrid = document.querySelector(".product-grid");
  const $slider = document.querySelector(".range-slider");
  const $thumb = document.querySelector(".range-slider-thumb");
  const $sliderWrapper = document.querySelector(".range-grid-wrapper");
  const $iconSmall = document.querySelector(".icon-grid-small-mobile");
  const $iconLarge = document.querySelector(".icon-grid-large-mobile");
  const $buttonsWrapper = document.querySelector(".button-columns-wrapper");
  const $subcategoryProductsSliders = document.querySelectorAll(
    ".grid-subcategory-products-slider"
  );
  const grid_transition_duration = 200;
  const min_columns = 2;
  const max_columns = 4;
  const addGridTransition = () => $productGrid.classList.add("grid-transition");
  const removeGridTransition = () =>
    $productGrid.classList.remove("grid-transition");

  //Handle grid mobile classes and  transition effect
  const updateGridClasses = (value) => {
    addGridTransition();
    setTimeout(() => {
      $productGrid.classList.remove(
        "grid--2-col-mobile",
        "grid--3-col-mobile",
        "grid--4-col-mobile"
      );
      $productGrid.classList.add(`grid--${value}-col-mobile`);
      removeGridTransition();
    }, grid_transition_duration);
  };

  //Handle thumb and slider position/animation
  const updateThumbPosition = () => {
    const value = parseInt($slider.value);
    const sliderWidth = $sliderWrapper.offsetWidth;
    const thumbWidth = $thumb.offsetWidth;
    const position =
      ((value - min_columns) / (max_columns - min_columns)) *
      (sliderWidth - thumbWidth);

    $thumb.style.transform = `translateX(${position}px) translateY(-50%)`;

    const sliderPercentage =
      ((value - min_columns) / (max_columns - min_columns)) * 100;
    $slider.style.background = `linear-gradient(to right, #333333 ${sliderPercentage}%, #E5E5E5 ${sliderPercentage}%)`;

    updateGridClasses(value);

    const eventName = window.FarmRio.events.mobileProductGrid;
    const customEvent = new CustomEvent(eventName, { detail: value });
    document.dispatchEvent(customEvent);
  };

  // Handle slider value and thumb position based on icon click
  const adjustSliderValue = (amount) => {
    let currentValue = parseInt($slider.value);
    let newValue = currentValue + amount;

    if (newValue < min_columns) {
      newValue = min_columns;
    }

    if (newValue > max_columns) {
      newValue = max_columns;
    }

    $slider.value = newValue;
    updateThumbPosition();
  };

  if ($iconSmall) {
    $iconSmall.addEventListener("click", () => adjustSliderValue(-1));
  }

  if ($iconLarge) {
    $iconLarge.addEventListener("click", () => adjustSliderValue(1));
  }

  if ($slider) {
    $slider.addEventListener("input", updateThumbPosition);
    $slider.addEventListener("change", updateThumbPosition);
  }

  //Handle grid change on desktop
  const changeCol = (event) => {
    const button = event.target.closest(".col-button");
    if (!button) return;

    const colsQuantity = button.dataset.colsQuantity;

    $subcategoryProductsSliders.forEach((slider) => {
      slider.style.display = button.classList.contains("three-col-button")
        ? "list-item"
        : "none";
    });

    if (window.innerWidth > 768) {
      const classColTablet = `grid--${colsQuantity}-col-tablet`;
      const classColNotebook = `grid--${colsQuantity}-col-notebook`;

      $productGrid.classList.remove(
        "grid--3-col-tablet",
        "grid--6-col-tablet",
        "grid--9-col-tablet",
        "grid--3-col-notebook",
        "grid--6-col-notebook",
        "grid--9-col-notebook"
      );
      $productGrid.classList.add(
        window.innerWidth > 992 ? classColNotebook : classColTablet
      );
    }

    const eventName = window.FarmRio.events.productGridClick;
    const customEvent = new CustomEvent(eventName, { detail: colsQuantity });
    document.dispatchEvent(customEvent);
  };

  if ($buttonsWrapper) {
    const buttons = $buttonsWrapper.querySelectorAll("button");
    buttons.forEach((button) => button.addEventListener("click", changeCol));
  }

  const haveFilterActive = location.search.includes("filter");
  const productPerPage = document.querySelector("#ProductGridContainer").dataset
    .productsPerPage;

  if (haveFilterActive) {
    const filterCountContainer = document.querySelector("#js-filter-count");
    const listItems = document.querySelectorAll("#product-grid li");
    const listItemsCount = listItems.length;

    if (listItemsCount >= parseInt(productPerPage)) {
      filterCountContainer.innerText = "+" + productPerPage + " productos";
    } else {
      filterCountContainer.innerText =
        listItemsCount > 1
          ? listItemsCount + " productos"
          : listItemsCount + " producto";
    }
  }
}
if (!window.productGridInitialized) {
  document.addEventListener("DOMContentLoaded", initProductGrid);
  window.productGridInitialized = true;
}
